// import React from "react";
// import { useNavigate } from "react-router-dom";
// import { readersData } from "../../../global/utils/constants/readersData";

// const ProductCard = ({
//   title,
//   info,
//   offer,
//   actual,
//   img,
//   id,
//   slug,
//   readers_icons,
// }) => {
//   const navigate = useNavigate();

//   // Filter readers - exact same logic as ProductInfo
//   const filteredReaders = readersData.filter((reader) =>
//     readers_icons?.some((d) => d.value === reader.id)
//   );

//   return (
//     <div
//       onClick={() => navigate(`/product/${slug}`)}
//       className="flex flex-col w-full h-full bg-white cursor-pointer transition-all duration-200 rounded-sm border border-[#e3e6e6] hover:shadow-[0_4px_8px_rgba(0,0,0,0.1)] hover:border-[#c7d1d8] overflow-hidden group"
//     >
//       {/* Image Container - Figma Specs: 200×153px with aspect-ratio 200/153 */}
//       <div className="w-full h-[200px] bg-[#f6f8fa] flex items-start justify-center relative overflow-hidden shrink-0 pt-[23.5px]">
//         <div
//           style={{
//             width: "200px",
//             height: "153px",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             flexShrink: 0,
//           }}
//         >
//           <img
//             src={img?.replace("static", "uploads")}
//             alt={title}
//             className="mix-blend-multiply transition-transform duration-200 group-hover:scale-105"
//             style={{
//               maxWidth: "200px",
//               maxHeight: "153px",
//               width: "auto",
//               height: "auto",
//               objectFit: "contain",
//               display: "block",
//             }}
//           />
//         </div>
//       </div>

//       {/* Content Container */}
//       <div className="flex-1 px-3 py-1 flex flex-col min-h-[110px]">
//         {/* Title - Amazon Typography */}
//         <h3 className="text-[#0F1111] text-sm leading-[1.3] line-clamp-2 mb-0 group-hover:text-[#C7511F] group-hover:underline transition-all cursor-pointer font-normal py-2">
//           {title}
//         </h3>

//         {/* Description */}
//         {info && (
//           <p className="text-[#5e5e5e] text-xs leading-[1.4] line-clamp-2 mb-1.5">
//             {info}
//           </p>
//         )}

//         {/* Reader Icons - Always rendered with fixed min-height */}
//         <div className="flex items-center flex-wrap gap-[3px] border-[#e7e7e7] min-h-[22px]">
//           {filteredReaders?.length > 0 && (
//             <>
//               {filteredReaders.slice(0, 4).map((reader, index) => (
//                 <div
//                   key={index}
//                   className="inline-flex items-center gap-1 px-1.5 py-0.5 bg-[#f7f8f8] border border-[#d5d9d9] rounded-sm text-[#016FFC] hover:bg-[#ededed] hover:border-[#babfc3] transition-all duration-150 cursor-default"
//                   title={reader?.title}
//                   onClick={(e) => e.stopPropagation()}
//                 >
//                   <img
//                     src={reader?.image}
//                     alt={reader?.title}
//                     className="w-3 h-3 object-contain"
//                     style={{
//                       filter:
//                         "invert(27%) sepia(97%) saturate(3066%) hue-rotate(201deg) brightness(98%) contrast(101%)",
//                     }}
//                   />
//                   <span className="text-[9px] font-medium leading-tight whitespace-nowrap">
//                     {reader?.title}
//                   </span>
//                 </div>
//               ))}
//               {filteredReaders.length > 4 && (
//                 <span className="text-[9px] text-[#565959] ml-0.5">
//                   +{filteredReaders.length - 4} more
//                 </span>
//               )}
//             </>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProductCard;
// import React from "react";
// import { useNavigate } from "react-router-dom";
// import { readersData } from "../../../global/utils/constants/readersData";

// const ProductCard = ({
//   title,
//   info,
//   offer,
//   actual,
//   img,
//   id,
//   slug,
//   readers_icons,
// }) => {
//   const navigate = useNavigate();

//   // Filter readers - exact same logic as ProductInfo
//   const filteredReaders = readersData.filter((reader) =>
//     readers_icons?.some((d) => d.value === reader.id)
//   );

//   return (
//     <div
//       onClick={() => navigate(`/product/${slug}`)}
//       className="flex flex-col w-full h-full bg-white cursor-pointer transition-all duration-200 rounded-lg border border-[#e0e0e0] hover:shadow-lg hover:border-[#c0c0c0] overflow-hidden group"
//     >
//       {/* Image Container - Figma Specs: 200×153px with aspect-ratio 200/153 */}
//       <div className="w-full h-[200px] bg-[#F7F7F7] flex items-start justify-center relative overflow-hidden shrink-0 pt-[23.5px]">
//         <div
//           style={{
//             width: "200px",
//             height: "153px",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             flexShrink: 0,
//           }}
//         >
//           <img
//             src={img?.replace("static", "uploads")}
//             alt={title}
//             className="mix-blend-multiply transition-transform duration-200 group-hover:scale-105"
//             style={{
//               maxWidth: "200px",
//               maxHeight: "153px",
//               width: "auto",
//               height: "auto",
//               objectFit: "contain",
//               display: "block",
//             }}
//           />
//         </div>
//       </div>

//       {/* Content Container */}
//       <div className="flex-1 px-4 py-1 flex flex-col min-h-[110px] bg-white">
//         {/* Title - Amazon Typography */}
//         <h6 className="text-[#0F1111] text-base leading-[1.4] line-clamp-2 mb-0 group-hover:text-[#016FFC] group-hover:underline transition-all cursor-pointer ">
//           {title}
//         </h6>

//         {/* Description */}
//         {info && (
//           <p className="text-[#3f3f3f] text-xs leading-[1.4] line-clamp-2 mb-1.5">
//             {info}
//           </p>
//         )}

//         {/* Reader Icons - Always rendered with fixed min-height */}
//         <div className="flex items-center flex-wrap gap-[3px] border-[#e7e7e7] min-h-[22px]">
//           {filteredReaders?.length > 0 && (
//             <>
//               {filteredReaders.slice(0, 4).map((reader, index) => (
//                 <div
//                   key={index}
//                   className="inline-flex items-center gap-1 px-1.5 py-0.5 bg-[#f7f8f8] border border-[#d5d9d9] rounded-sm text-[#016FFC] hover:bg-[#ededed] hover:border-[#babfc3] transition-all duration-150 cursor-default"
//                   title={reader?.title}
//                   onClick={(e) => e.stopPropagation()}
//                 >
//                   <img
//                     src={reader?.image}
//                     alt={reader?.title}
//                     className="w-3 h-3 object-contain"
//                     style={{
//                       filter:
//                         "invert(27%) sepia(97%) saturate(3066%) hue-rotate(201deg) brightness(98%) contrast(101%)",
//                     }}
//                   />
//                   <span className="text-[9px] font-medium leading-tight whitespace-nowrap">
//                     {reader?.title}
//                   </span>
//                 </div>
//               ))}
//               {filteredReaders.length > 4 && (
//                 <span className="text-[9px] text-[#565959] ml-0.5">
//                   +{filteredReaders.length - 4} more
//                 </span>
//               )}
//             </>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProductCard;
// import React from "react";
// import { useNavigate } from "react-router-dom";
// import { readersData } from "../../../global/utils/constants/readersData";

// const ProductCard = ({
//   title,
//   info,
//   offer,
//   actual,
//   img,
//   id,
//   slug,
//   readers_icons,
// }) => {
//   const navigate = useNavigate();

//   // Filter readers - exact same logic as ProductInfo
//   const filteredReaders = readersData.filter((reader) =>
//     readers_icons?.some((d) => d.value === reader.id)
//   );

//   return (
//     <div
//       onClick={() => navigate(`/product/${slug}`)}
//       className="flex flex-col w-full h-full bg-white cursor-pointer transition-all duration-300 rounded-xl border border-[#e5e7eb] hover:shadow-xl hover:border-[#016FFC] overflow-hidden group"
//     >
//       {/* Image Container - Same size as original (200px height) */}
//       <div className="w-full h-[200px] bg-gradient-to-br from-[#F9FAFB] to-[#F3F4F6] flex items-start justify-center relative overflow-hidden shrink-0 pt-[23.5px]">
//         {/* Subtle background pattern */}
//         <div
//           className="absolute inset-0 opacity-[0.02]"
//           style={{
//             backgroundImage: "radial-gradient(circle, #000 1px, transparent 1px)",
//             backgroundSize: "24px 24px",
//           }}
//         />

//         <div
//           className="relative z-10"
//           style={{
//             width: "200px",
//             height: "153px",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             flexShrink: 0,
//           }}
//         >
//           <img
//             src={img?.replace("static", "uploads")}
//             alt={title}
//             className="mix-blend-multiply transition-transform duration-300 group-hover:scale-105"
//             style={{
//               maxWidth: "200px",
//               maxHeight: "153px",
//               width: "auto",
//               height: "auto",
//               objectFit: "contain",
//               display: "block",
//             }}
//           />
//         </div>
//       </div>

//       {/* Content Container - Same min-height as original (110px) */}
//       <div className="flex-1 px-4 py-3 flex flex-col min-h-[110px] bg-white">
//         {/* Title - Improved with better hover state */}
//         <h6 className="text-[#0F1111] text-base leading-[1.4] line-clamp-2 mb-1 group-hover:text-[#016FFC] transition-colors duration-200">
//           {title}
//         </h6>

//         {/* Description - Better color and spacing */}
//         {info && (
//           <p className="text-[#565959] text-xs leading-[1.5] line-clamp-2 mb-2">
//             {info}
//           </p>
//         )}

//         {/* Reader Icons - Improved design with subtle enhancements */}
//         <div className="flex items-center flex-wrap gap-1.5 mt-auto min-h-[22px]">
//           {filteredReaders?.length > 0 && (
//             <>
//               {filteredReaders.slice(0, 4).map((reader, index) => (
//                 <div
//                   key={index}
//                   className="inline-flex items-center gap-1 px-2 py-1 bg-[#f0f7ff] border border-[#d6e8ff] rounded-md text-[#016FFC] hover:bg-[#e6f2ff] hover:border-[#016FFC] hover:shadow-sm transition-all duration-150 cursor-default"
//                   title={reader?.title}
//                   onClick={(e) => e.stopPropagation()}
//                 >
//                   <img
//                     src={reader?.image}
//                     alt={reader?.title}
//                     className="w-3 h-3 object-contain"
//                     style={{
//                       filter:
//                         "invert(27%) sepia(97%) saturate(3066%) hue-rotate(201deg) brightness(98%) contrast(101%)",
//                     }}
//                   />
//                   <span className="text-[9px] font-semibold leading-tight whitespace-nowrap">
//                     {reader?.title}
//                   </span>
//                 </div>
//               ))}
//               {filteredReaders.length > 4 && (
//                 <span className="text-[9px] text-[#868686] font-medium px-1.5 py-1 bg-[#f5f5f5] rounded-md">
//                   +{filteredReaders.length - 4} more
//                 </span>
//               )}
//             </>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProductCard;
import React from "react";
import { useNavigate } from "react-router-dom";
import { readersData } from "../../../global/utils/constants/readersData";

const ProductCard = ({
  title,
  info,
  offer,
  actual,
  img,
  id,
  slug,
  readers_icons,
}) => {
  const navigate = useNavigate();

  // Filter readers - exact same logic as ProductInfo
  const filteredReaders = readersData.filter((reader) =>
    readers_icons?.some((d) => d.value === reader.id)
  );

  return (
    <div
      onClick={() => navigate(`/product/${slug}`)}
      className="flex flex-col w-full h-full bg-white cursor-pointer transition-all duration-500 ease-out rounded-2xl border border-gray-200 hover:border-blue-400 hover:shadow-2xl hover:shadow-blue-100/50 overflow-hidden group relative"
    >
      {/* Subtle top accent line */}
      <div className="absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-blue-500 via-blue-600 to-blue-500 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

      {/* Image Container - Premium styling */}
      <div className="w-full h-[200px] bg-gradient-to-br from-slate-50 via-gray-50 to-slate-100 flex items-start justify-center relative overflow-hidden shrink-0 pt-[23.5px]">
        {/* Animated gradient background on hover */}
        <div className="absolute inset-0 bg-gradient-to-br from-blue-50/0 via-blue-50/0 to-blue-100/0 group-hover:from-blue-50/30 group-hover:via-blue-50/10 group-hover:to-blue-100/30 transition-all duration-700"></div>

        {/* Subtle grid pattern */}
        <div
          className="absolute inset-0 opacity-[0.015]"
          style={{
            backgroundImage:
              "linear-gradient(0deg, #0000 49%, #000 49%, #000 51%, #0000 51%), linear-gradient(90deg, #0000 49%, #000 49%, #000 51%, #0000 51%)",
            backgroundSize: "30px 30px",
          }}
        />

        <div
          className="relative z-10"
          style={{
            width: "200px",
            height: "153px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <img
            src={img?.replace("static", "uploads")}
            alt={title}
            className="mix-blend-multiply transition-all duration-500 ease-out group-hover:scale-[1.08] group-hover:brightness-105"
            style={{
              maxWidth: "200px",
              maxHeight: "153px",
              width: "auto",
              height: "auto",
              objectFit: "contain",
              display: "block",
              filter: "drop-shadow(0 2px 8px rgba(0,0,0,0.06))",
            }}
          />
        </div>

        {/* Corner shine effect */}
        <div className="absolute -top-20 -right-20 w-40 h-40 bg-gradient-to-br from-white/40 to-transparent rounded-full blur-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-700"></div>
      </div>

      {/* Content Container - Enhanced spacing and typography */}
      <div className="flex-1 px-4 py-3 flex flex-col min-h-[110px] bg-white relative">
        {/* Title - Premium typography with smooth transitions */}
        <h6 className="text-gray-900 text-base font-medium leading-[1.4] line-clamp-2 mb-1 group-hover:text-blue-600 transition-all duration-300 tracking-tight">
          {title}
        </h6>

        {/* Description - Enhanced readability */}
        {info && (
          <p className="text-gray-600 text-xs leading-[1.5] line-clamp-2 mb-2 transition-colors duration-300 group-hover:text-gray-700">
            {info}
          </p>
        )}

        {/* Reader Icons - World-class badge design */}
        <div className="flex items-center flex-wrap gap-1.5 mt-auto min-h-[22px]">
          {filteredReaders?.length > 0 && (
            <>
              {filteredReaders.slice(0, 4).map((reader, index) => (
                <div
                  key={index}
                  className="inline-flex items-center gap-1.5 px-2.5 py-[5px] bg-gradient-to-br from-blue-50 to-blue-100/50 border border-blue-200/60 rounded-lg text-blue-700 hover:from-blue-100 hover:to-blue-200/60 hover:border-blue-300 hover:shadow-md hover:shadow-blue-100/50 hover:-translate-y-0.5 transition-all duration-300 cursor-default group/badge"
                  title={reader?.title}
                  onClick={(e) => e.stopPropagation()}
                >
                  <img
                    src={reader?.image}
                    alt={reader?.title}
                    className="w-3.5 h-3.5 object-contain transition-transform duration-300 group-hover/badge:scale-110 group-hover/badge:rotate-3"
                    style={{
                      filter:
                        "invert(27%) sepia(97%) saturate(3066%) hue-rotate(201deg) brightness(98%) contrast(101%)",
                    }}
                  />
                  <span className="text-[9.5px] font-bold leading-tight whitespace-nowrap tracking-wide">
                    {reader?.title}
                  </span>
                </div>
              ))}
              {filteredReaders.length > 4 && (
                <span className="text-[9.5px] text-gray-500 font-semibold px-2.5 py-1.5 bg-gradient-to-br from-gray-100 to-gray-200/50 border border-gray-200 rounded-lg tracking-wide">
                  +{filteredReaders.length - 4}
                </span>
              )}
            </>
          )}
        </div>

        {/* Bottom gradient fade effect */}
        <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
      </div>
    </div>
  );
};

export default ProductCard;
